import apiClient from './api';
import { cachedGet, invalidate } from './apiCache';
import { Item, CreateItemDto, UpdateItemDto, Category, Unit, ItemUnit, CreateItemUnitDto, UpdateItemUnitDto } from '../types/items.types';
export const itemsService = {
  getAll: async (includeInactive: boolean = false): Promise<Item[]> => {
    return cachedGet(`items_all_${includeInactive}`, async () => {
      const response = await apiClient.get<Item[]>(`/Items?includeInactive=${includeInactive}`);
      return response.data;
    });
  },
  getBakeryItems: async (): Promise<Item[]> => {
    return cachedGet('items_bakery', async () => {
      const response = await apiClient.get<Item[]>('/Items?bakeryOnly=true');
      return response.data;
    });
  },
  getBakeryPurchaseItems: async (): Promise<Item[]> => {
    return cachedGet('items_bakeryPurchase', async () => {
      const response = await apiClient.get<Item[]>('/Items?bakeryPurchaseOnly=true');
      return response.data;
    });
  },
  getAllExcludingBakeryPurchase: async (includeInactive: boolean = false): Promise<Item[]> => {
    return cachedGet(`items_excludeBakery_${includeInactive}`, async () => {
      const response = await apiClient.get<Item[]>(`/Items?includeInactive=${includeInactive}&excludeBakeryPurchase=true`);
      return response.data;
    });
  },
  getById: async (id: number): Promise<Item> => {
    const response = await apiClient.get<Item>(`/Items/${id}`);
    return response.data;
  },
  create: async (data: CreateItemDto): Promise<Item> => {
    const response = await apiClient.post<Item>('/Items', data);
    invalidate('items_');
    return response.data;
  },
  update: async (id: number, data: UpdateItemDto): Promise<Item> => {
    const response = await apiClient.put<Item>(`/Items/${id}`, data);
    invalidate('items_');
    return response.data;
  },
  delete: async (id: number): Promise<void> => {
    await apiClient.delete(`/Items/${id}`);
    invalidate('items_');
  },
  generateCode: async (): Promise<string> => {
    const response = await apiClient.get<string>('/Items/generate-code');
    return response.data;
  },
};
export const categoriesService = {
  getAll: async (): Promise<Category[]> => {
    return cachedGet('categories_all', async () => {
      const response = await apiClient.get<Category[]>('/Categories');
      return response.data;
    });
  },
};
export const unitsService = {
  getAll: async (): Promise<Unit[]> => {
    return cachedGet('units_all', async () => {
      const response = await apiClient.get<Unit[]>('/Units');
      return response.data;
    });
  },
};
// ItemUnits Service
export const itemUnitsService = {
  getItemUnits: async (itemId: number): Promise<ItemUnit[]> => {
    const response = await apiClient.get<ItemUnit[]>(`/Items/${itemId}/units`);
    return response.data;
  },
  getById: async (itemUnitId: number): Promise<ItemUnit> => {
    const response = await apiClient.get<ItemUnit>(`/Items/units/${itemUnitId}`);
    return response.data;
  },
  create: async (data: CreateItemUnitDto): Promise<ItemUnit> => {
    const response = await apiClient.post<ItemUnit>('/Items/units', data);
    return response.data;
  },
  update: async (itemUnitId: number, data: UpdateItemUnitDto): Promise<ItemUnit> => {
    const response = await apiClient.put<ItemUnit>(`/Items/units/${itemUnitId}`, data);
    return response.data;
  },
  delete: async (itemUnitId: number): Promise<void> => {
    await apiClient.delete(`/Items/units/${itemUnitId}`);
  },
};